export const httpUpdateOrganizationsError =
  'status 500 reading SecurityServiceClient#changeUserOrganizations(List,String)';
